import { types as reportTypes } from 'actions/report'
import { types as tagTypes } from 'actions/tag'
import { createSelector } from 'reselect'

export default function reducer (state = {}, action) {
  switch (action.type) {
    case reportTypes.LOAD_REPORT:
    case tagTypes.LOAD_TAG:
      return { ...state, ...action.dictionaries }
  }
  return state
}


export const getTable = createSelector(
  (table, models) => ({ table, models }),
  ({ table, models }) => models.find(m => m.table === table),
)

export const getField = createSelector(
  (table, field) => ({ table, field }),
  ({ table, field }) => table.fields?.find(m => m.field === field),
)

export const selectors = {
  getTable,
  getField,
}